import React, { useEffect, useState } from 'react';
import { getRequest, postRequest } from '../../../Utils/AppApi';
import { APP_INFO_URL } from './../../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { Switch, Tooltip, Input, InputNumber } from 'antd';
import {
    SaveOutlined,
    SettingOutlined,
    MailOutlined,
    PhoneOutlined,
    LinkOutlined,
    LockOutlined,
    SafetyOutlined,
    TransactionOutlined,
    BankOutlined,
    GlobalOutlined,
    InfoCircleOutlined,
    QrcodeOutlined,
    CreditCardOutlined,
    CarOutlined,
    FileProtectOutlined,
    ScanOutlined,
    ThunderboltOutlined,
    WalletOutlined,
    DashboardOutlined,
    AppstoreOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MenuOutlined,
    ControlOutlined,
    ApiOutlined,
    SecurityScanOutlined,
    DollarOutlined
} from '@ant-design/icons';
import './appInfo.css';

function AppInfo(props) {
    const history = useHistory();

    // Feature switches state
    const [isDmtLimit, setDmtLimit] = useState(false);
    const [isOtpLogin, setOtpLogin] = useState(false);
    const [isPayoutEnabled, setPayoutEnabled] = useState(false);
    const [isMoveToBankEnabled, setMoveToBankEnabled] = useState(false);
    const [isFinoSuvidhaEnabled, setFinoSuvidhaEnabled] = useState(false);
    const [isBbpsImWalletEnabled, setBbpsImWalletEnabled] = useState(false);
    const [isBbpsIpEnabled, setBbpsIpEnabled] = useState(true);
    const [isScanPayEnabled, setScanPayEnabled] = useState(true);
    const [isCreditCardEnabled, setCreditCardEnabled] = useState(true);
    const [isFastagEnabled, setFastagEnabled] = useState(true);
    const [isLicPremiumEnabled, setLicPremiumEnabled] = useState(true);
    const [isUtilityOfflineEnabled, setUtilityOfflineEnabled] = useState(true);
    const [isAadhaarPayEnabled, setAadhaarPayEnabled] = useState(false);
    const [isCashDepositEnabled, setCashDepositEnabled] = useState(false);
    const [isMaintenance, setMaintenance] = useState(false);
    // NEW: AePS OTP toggle
    const [isAePSOTP, setAePSOTP] = useState(false);
    // NEW: FingPay QR ATM toggle
    const [isFpQRAtmEnabled, setFpQRAtmEnabled] = useState(true);

    const [getDataInfo, setDataInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('general');
    const [searchTerm, setSearchTerm] = useState('');

    const onChangeValue = (event) => {
        const { name, value } = event.target;
        setDataInfo({ ...getDataInfo, [name]: value });
    };

    const onChangeNumberValue = (name, value) => {
        setDataInfo({ ...getDataInfo, [name]: value });
    };

    // Switch change handlers for all features
    const onChangeSwitch = (checked) => {
        setDmtLimit(checked);
        setDataInfo({ ...getDataInfo, dmtTransactionLimit: checked });
    };

    const onChangeOtpLoginSwitch = (checked) => {
        setOtpLogin(checked);
        setDataInfo({ ...getDataInfo, isOtpLoginEnable: checked });
    };

    const onChangePayoutSwitch = (checked) => {
        setPayoutEnabled(checked);
        setDataInfo({ ...getDataInfo, payoutEnabled: checked });
    };

    const onChangeMoveToBankSwitch = (checked) => {
        setMoveToBankEnabled(checked);
        setDataInfo({ ...getDataInfo, moveToBankEnabled: checked });
    };

    const onChangeFinoSuvidhaSwitch = (checked) => {
        setFinoSuvidhaEnabled(checked);
        setDataInfo({ ...getDataInfo, finoSuvidhaEnabled: checked });
    };

    const onChangeBbpsImWalletSwitch = (checked) => {
        setBbpsImWalletEnabled(checked);
        setDataInfo({ ...getDataInfo, bbpsImWalletEnabled: checked });
    };

    const onChangeBbpsIpSwitch = (checked) => {
        setBbpsIpEnabled(checked);
        setDataInfo({ ...getDataInfo, bbpsIpEnabled: checked });
    };

    const onChangeScanPaySwitch = (checked) => {
        setScanPayEnabled(checked);
        setDataInfo({ ...getDataInfo, scanPayEnabled: checked });
    };

    const onChangeCreditCardSwitch = (checked) => {
        setCreditCardEnabled(checked);
        setDataInfo({ ...getDataInfo, creditCardEnabled: checked });
    };

    const onChangeFastagSwitch = (checked) => {
        setFastagEnabled(checked);
        setDataInfo({ ...getDataInfo, fastagEnabled: checked });
    };

    const onChangeLicPremiumSwitch = (checked) => {
        setLicPremiumEnabled(checked);
        setDataInfo({ ...getDataInfo, licPremiumEnabled: checked });
    };

    const onChangeUtilityOfflineSwitch = (checked) => {
        setUtilityOfflineEnabled(checked);
        setDataInfo({ ...getDataInfo, utilityOfflineEnabled: checked });
    };

    const onChangeAadhaarPaySwitch = (checked) => {
        setAadhaarPayEnabled(checked);
        setDataInfo({ ...getDataInfo, aadhaarPayEnabled: checked });
    };

    const onChangeCashDepositSwitch = (checked) => {
        setCashDepositEnabled(checked);
        setDataInfo({ ...getDataInfo, cashDepositEnabled: checked });
    };

    const onChangeMaintenanceSwitch = (checked) => {
        setMaintenance(checked);
        setDataInfo({ ...getDataInfo, isMaintenance: checked });
    };

    // NEW: Handler for AePS OTP
    const onChangeAePSOTPSwitch = (checked) => {
        setAePSOTP(checked);
        setDataInfo({ ...getDataInfo, isAePSOTP: checked });
    };

    // NEW: Handler for FingPay QR ATM
    const onChangeFpQRAtmSwitch = (checked) => {
        setFpQRAtmEnabled(checked);
        setDataInfo({ ...getDataInfo, fpQRAtmEnabled: checked });
    };

    const handleSubmit = () => {
        setLoading(true);
        postRequest(APP_INFO_URL, getDataInfo)
            .then((response) => {
                if (response.success === true) {
                    toast.success('Settings saved successfully!');
                } else {
                    toast.error(response.message);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error('Failed to update settings');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const getAppData = () => {
        getRequest(APP_INFO_URL, history)
            .then((response) => {
                setDmtLimit(response.dmtTransactionLimit || false);
                setOtpLogin(response.isOtpLoginEnable || false);
                setPayoutEnabled(response.payoutEnabled || false);
                setMoveToBankEnabled(response.moveToBankEnabled || false);
                setFinoSuvidhaEnabled(response.finoSuvidhaEnabled || false);
                setBbpsImWalletEnabled(response.bbpsImWalletEnabled || false);
                setBbpsIpEnabled(response.bbpsIpEnabled !== undefined ? response.bbpsIpEnabled : true);
                setScanPayEnabled(response.scanPayEnabled !== undefined ? response.scanPayEnabled : true);
                setCreditCardEnabled(response.creditCardEnabled !== undefined ? response.creditCardEnabled : true);
                setFastagEnabled(response.fastagEnabled !== undefined ? response.fastagEnabled : true);
                setLicPremiumEnabled(response.licPremiumEnabled !== undefined ? response.licPremiumEnabled : true);
                setUtilityOfflineEnabled(response.utilityOfflineEnabled !== undefined ? response.utilityOfflineEnabled : true);
                setAadhaarPayEnabled(response.aadhaarPayEnabled || false);
                setCashDepositEnabled(response.cashDepositEnabled || false);
                setMaintenance(response.isMaintenance || false);
                // NEW: load AePS OTP state
                setAePSOTP(response.isAePSOTP || false);
                // NEW: load FingPay QR ATM state (default true)
                setFpQRAtmEnabled(response.fpQRAtmEnabled !== undefined ? response.fpQRAtmEnabled : true);
                setDataInfo(response);
            })
            .catch((error) => {
                console.log(error);
                toast.error('Failed to load settings');
            });
    };

    useEffect(() => {
        getAppData();
    }, []);

    // Tabs configuration
    const tabs = [
        { id: 'general', label: 'General', icon: <SettingOutlined />, description: 'Basic application settings' },
        { id: 'security', label: 'Security', icon: <SafetyOutlined />, description: 'Security and authentication' },
        { id: 'transactions', label: 'Transactions', icon: <TransactionOutlined />, description: 'Transaction limits and timing' },
        { id: 'integrations', label: 'Integrations', icon: <LinkOutlined />, description: 'Social media integrations' },
        { id: 'payments', label: 'Payments', icon: <WalletOutlined />, description: 'Payment gateway settings' },
        { id: 'features', label: 'Menu Control', icon: <MenuOutlined />, description: 'Feature toggles & menu visibility' },
    ];

    // Field configurations
    const fieldConfigs = {
        general: [
            { label: 'Logo URL', name: 'logo', type: 'text', icon: <GlobalOutlined />, tooltip: 'URL for application logo', placeholder: 'https://example.com/logo.png' },
            { label: 'Email', name: 'email', type: 'email', icon: <MailOutlined />, tooltip: 'Primary contact email for support', placeholder: 'support@example.com' },
            { label: 'Help Number', name: 'helpNumber', type: 'tel', icon: <PhoneOutlined />, tooltip: 'Customer support phone number', placeholder: '+91 9876543210' },
            { label: 'Ad Image URL', name: 'adImage', type: 'text', icon: <GlobalOutlined />, tooltip: 'URL for advertisement image', placeholder: 'https://example.com/ad.jpg' },
            { label: 'Mobile Version', name: 'mobileVersion', type: 'text', icon: <SettingOutlined />, tooltip: 'Current mobile app version', placeholder: '1.0.0' },
            { label: 'Username Number', name: 'usernameNumber', type: 'number', icon: <SettingOutlined />, tooltip: 'Number format for usernames', placeholder: '0' },
            { label: 'Wallet Length', name: 'walletLength', type: 'number', icon: <WalletOutlined />, tooltip: 'Length of wallet IDs', placeholder: '10' },
            { label: "IM Wallet Web Token", name: "imWalletWebToken", type: "text", icon: <GlobalOutlined />, tooltip: 'Web token for IM Wallet integration', placeholder: 'Enter IM Wallet Web Token' },
            { label: 'Transaction ID Start', name: 'transactionIdStart', type: 'number', icon: <TransactionOutlined />, tooltip: 'Starting number for transaction IDs', placeholder: '1' },
            { label: 'Today Date', name: 'todayDate', type: 'date', icon: <SettingOutlined />, tooltip: 'Current date reference', placeholder: 'YYYY-MM-DD' }
        ],
        security: [
            { label: 'Maximum Login Device', name: 'maximumLoginDevice', type: 'number', icon: <SafetyOutlined />, tooltip: 'Maximum number of devices allowed per user', placeholder: '3' },
            { label: 'Transaction ID Length', name: 'transactionIdLength', type: 'number', icon: <SafetyOutlined />, tooltip: 'Length of generated transaction IDs', placeholder: '10' },
            { label: 'Allowed Location Radius (KM)', name: 'allowedLocationRadius', type: 'number', icon: <GlobalOutlined />, tooltip: 'Maximum distance from registered location in kilometers', placeholder: '50' },
            { label: 'Allowed Domain', name: 'allowedDomain', type: 'text', icon: <GlobalOutlined />, tooltip: 'Restrict access to specific domains', placeholder: 'example.com' }
        ],
        transactions: [
            { label: 'DMT Next Transaction Time (Minutes)', name: 'dmtNextTransactionTime', type: 'number', icon: <TransactionOutlined />, tooltip: 'Minimum minutes between DMT transactions', placeholder: '5' },
            { label: 'Payout Next Transaction Time (Minutes)', name: 'payoutNextTransactionTime', type: 'number', icon: <TransactionOutlined />, tooltip: 'Minimum minutes between payout transactions', placeholder: '10' },
            { label: 'Payout Transaction Amount Limit', name: 'payoutTransactionAmountLimit', type: 'number', icon: <BankOutlined />, tooltip: 'Maximum payout transaction amount', placeholder: '50000' },
            { label: 'Quick Settlement Amount Limit', name: 'quickSettlementAmountLimit', type: 'number', icon: <BankOutlined />, tooltip: 'Maximum amount for quick settlement', placeholder: '10000' }
        ],
        integrations: [
            { label: 'Facebook', name: 'facebook', type: 'url', icon: <LinkOutlined />, tooltip: 'Facebook page URL', placeholder: 'https://facebook.com/yourpage' },
            { label: 'YouTube', name: 'youtube', type: 'url', icon: <LinkOutlined />, tooltip: 'YouTube channel URL', placeholder: 'https://youtube.com/yourchannel' },
            { label: 'LinkedIn', name: 'linkedin', type: 'url', icon: <LinkOutlined />, tooltip: 'LinkedIn company page URL', placeholder: 'https://linkedin.com/company' }
        ],
        payments: [
            { label: 'Payout Transaction Amount Limit', name: 'payoutTransactionAmountLimit', type: 'number', icon: <BankOutlined />, tooltip: 'Maximum amount for payout transactions', placeholder: '50000' },
            { label: 'Quick Settlement Amount Limit', name: 'quickSettlementAmountLimit', type: 'number', icon: <ThunderboltOutlined />, tooltip: 'Maximum amount for quick settlement', placeholder: '10000' }
        ]
    };

    // Complete switch configurations grouped by category for Menu Control
    const switchCategories = {
        'System Controls': [
            { label: 'Maintenance Mode', checked: isMaintenance, onChange: onChangeMaintenanceSwitch, icon: <SafetyOutlined />, tooltip: 'Put the application in maintenance mode', color: '#ef4444' },
        ],
        'Security Features': [
            { label: 'OTP Login', checked: isOtpLogin, onChange: onChangeOtpLoginSwitch, icon: <LockOutlined />, tooltip: 'Enable OTP-based authentication', color: '#10b981' },
        ],
        'Transaction Controls': [
            { label: 'DMT Transaction Limit', checked: isDmtLimit, onChange: onChangeSwitch, icon: <TransactionOutlined />, tooltip: 'Enable/disable DMT transaction limits', color: '#3b82f6' },
        ],
        'Payment Features': [
            { label: 'Fund Settlement (Payout)', checked: isPayoutEnabled, onChange: onChangePayoutSwitch, icon: <DollarOutlined />, tooltip: 'Enable fund settlement functionality', color: '#f59e0b' },
            { label: 'Move to Bank', checked: isMoveToBankEnabled, onChange: onChangeMoveToBankSwitch, icon: <BankOutlined />, tooltip: 'Enable bank transfer feature', color: '#f59e0b' },
            { label: 'Scan & Pay', checked: isScanPayEnabled, onChange: onChangeScanPaySwitch, icon: <ScanOutlined />, tooltip: 'Enable scan and pay feature', color: '#06b6d4' },
            { label: 'FingPay QR ATM', checked: isFpQRAtmEnabled, onChange: onChangeFpQRAtmSwitch, icon: <QrcodeOutlined />, tooltip: 'Enable FingPay QR ATM feature', color: '#8b5cf6' },

            { label: 'Credit Card', checked: isCreditCardEnabled, onChange: onChangeCreditCardSwitch, icon: <CreditCardOutlined />, tooltip: 'Enable credit card payments', color: '#06b6d4' },
            { label: 'Fastag', checked: isFastagEnabled, onChange: onChangeFastagSwitch, icon: <CarOutlined />, tooltip: 'Enable Fastag recharge and payments', color: '#06b6d4' },
            { label: 'LIC Premium', checked: isLicPremiumEnabled, onChange: onChangeLicPremiumSwitch, icon: <FileProtectOutlined />, tooltip: 'Enable LIC premium payments', color: '#06b6d4' },
            { label: 'Utility Offline', checked: isUtilityOfflineEnabled, onChange: onChangeUtilityOfflineSwitch, icon: <QrcodeOutlined />, tooltip: 'Enable offline utility payments', color: '#06b6d4' },
            { label: 'Cash Deposit', checked: isCashDepositEnabled, onChange: onChangeCashDepositSwitch, icon: <BankOutlined />, tooltip: 'Enable cash deposit feature', color: '#f59e0b' },
            // NEW: AePS OTP switch
            { label: 'AePS OTP', checked: isAePSOTP, onChange: onChangeAePSOTPSwitch, icon: <SafetyOutlined />, tooltip: 'Enable AePS OTP feature', color: '#8b5cf6' },
        ],
        'Integrations': [
            { label: 'Fino Suvidha', checked: isFinoSuvidhaEnabled, onChange: onChangeFinoSuvidhaSwitch, icon: <ApiOutlined />, tooltip: 'Enable Fino Suvidha integration', color: '#8b5cf6' },
            { label: 'BBPS IM Wallet', checked: isBbpsImWalletEnabled, onChange: onChangeBbpsImWalletSwitch, icon: <WalletOutlined />, tooltip: 'Enable BBPS IM Wallet integration', color: '#8b5cf6' },
            { label: 'BBPS IP', checked: isBbpsIpEnabled, onChange: onChangeBbpsIpSwitch, icon: <GlobalOutlined />, tooltip: 'Enable BBPS IP integration', color: '#8b5cf6' },
            { label: 'Aadhaar Pay', checked: isAadhaarPayEnabled, onChange: onChangeAadhaarPaySwitch, icon: <SecurityScanOutlined />, tooltip: 'Enable Aadhaar Pay integration', color: '#ec4899' },
        ]
    };

    // Flatten for search
    const allFeatures = Object.entries(switchCategories).flatMap(([category, features]) =>
        features.map(f => ({ ...f, category }))
    );

    const filteredFeatures = allFeatures.filter(feature =>
        feature.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        feature.category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredGroupedFeatures = filteredFeatures.reduce((groups, feature) => {
        const category = feature.category;
        if (!groups[category]) groups[category] = [];
        groups[category].push(feature);
        return groups;
    }, {});

    const renderField = (field, index) => (
        <div key={index} className='app-info-field-compact'>
            <div className="app-info-field-header">
                <label className="app-info-label-compact">
                    {field.icon}
                    <span>{field.label}</span>
                    <Tooltip title={field.tooltip}>
                        <InfoCircleOutlined className="app-info-field-info" />
                    </Tooltip>
                </label>
            </div>
            <div className="app-info-input-wrapper">
                {field.type === 'number' ? (
                    <InputNumber
                        className="app-info-input-compact"
                        name={field.name}
                        onChange={(value) => onChangeNumberValue(field.name, value)}
                        value={getDataInfo[field.name] || ''}
                        placeholder={field.placeholder}
                        style={{ width: '100%' }}
                    />
                ) : (
                    <input
                        type={field.type}
                        className="app-info-input-compact"
                        name={field.name}
                        onChange={onChangeValue}
                        value={getDataInfo[field.name] || ''}
                        placeholder={field.placeholder}
                    />
                )}
            </div>
        </div>
    );

    const renderSwitch = (switchItem, index) => (
        <div key={index} className='app-info-switch-item'>
            <div className="app-info-switch-header">
                <div className="app-info-switch-label">
                    <span className="app-info-switch-icon" style={{ color: switchItem.color }}>
                        {switchItem.icon}
                    </span>
                    <span className="app-info-switch-text">{switchItem.label}</span>
                    <Tooltip title={switchItem.tooltip}>
                        <InfoCircleOutlined className="app-info-switch-info" />
                    </Tooltip>
                </div>
                <div className="app-info-switch-control">
                    <span className={`app-info-switch-status ${switchItem.checked ? 'active' : ''}`}>
                        {switchItem.checked ? 'ON' : 'OFF'}
                    </span>
                    <Switch
                        checked={switchItem.checked}
                        onChange={switchItem.onChange}
                        className={`app-info-switch-compact ${switchItem.checked ? 'active' : ''}`}
                    />
                </div>
            </div>
        </div>
    );

    const renderSwitchGroup = (category, switches) => {
        const activeCount = switches.filter(s => s.checked).length;
        return (
            <div key={category} className="app-info-switch-group">
                <div className="app-info-switch-group-header">
                    <h4 className="app-info-switch-group-title">{category}</h4>
                    <span className="app-info-switch-group-count">
                        {activeCount}/{switches.length} Active
                    </span>
                </div>
                <div className="app-info-switches-grid">
                    {switches.map(renderSwitch)}
                </div>
            </div>
        );
    };

    // Calculate stats
    const totalFeatures = allFeatures.length;
    const activeFeatures = allFeatures.filter(f => f.checked).length;

    return (
        <div className="app-info-container-elegant">
            <div className="app-info-wrapper-compact">
                {/* Header */}
                <div className="app-info-header-elegant">
                    <div className="app-info-header-main">
                        <DashboardOutlined className="app-info-main-icon" />
                        <div className="app-info-header-content">
                            <h1 className="app-info-main-title">Application Settings</h1>
                            <p className="app-info-main-subtitle">
                                Configure and manage your application preferences
                            </p>
                        </div>
                    </div>
                    <button
                        className="app-info-save-btn"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        <SaveOutlined className="app-info-save-icon" />
                        {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>

                {/* Stats Bar */}
                <div className="app-info-stats-bar" style={{ display: 'flex', gap: '30px', padding: '20px 40px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                    <div className="app-info-stat-item">
                        <span className="app-info-stat-label">Total Features</span>
                        <span className="app-info-stat-number">{totalFeatures}</span>
                    </div>
                    <div className="app-info-stat-item">
                        <span className="app-info-stat-label">Active Features</span>
                        <span className="app-info-stat-number active" style={{ color: '#10b981' }}>{activeFeatures}</span>
                    </div>
                    <div className="app-info-stat-item">
                        <span className="app-info-stat-label">Completion</span>
                        <span className="app-info-stat-number">{Math.round((activeFeatures / totalFeatures) * 100)}%</span>
                    </div>
                    <div className="app-info-stat-item">
                        <span className="app-info-stat-label">Config Fields</span>
                        <span className="app-info-stat-number">{Object.keys(getDataInfo).filter(k => getDataInfo[k]).length}</span>
                    </div>
                </div>

                {/* Tabs */}
                <div className="app-info-tabs">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`app-info-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.icon}
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>

                {/* Content */}
                <div className="app-info-content-compact">
                    {activeTab !== 'features' ? (
                        <>
                            {/* Left Panel */}
                            <div className="app-info-left-panel">
                                <div className="app-info-section">
                                    <h3 className="app-info-section-title">
                                        {tabs.find(t => t.id === activeTab)?.label} Settings
                                    </h3>
                                    <div className="app-info-fields-grid">
                                        {fieldConfigs[activeTab]?.map(renderField)}
                                    </div>
                                </div>
                            </div>

                            {/* Right Panel - Quick Switches */}
                            <div className="app-info-right-panel">
                                <div className="app-info-features-card">
                                    <div className="app-info-features-header">
                                        <h3 className="app-info-features-title">Quick Feature Toggles</h3>
                                        <p className="app-info-features-subtitle">
                                            Frequently used controls
                                        </p>
                                    </div>
                                    <div className="app-info-switches-list">
                                        {allFeatures.slice(0, 6).map(renderSwitch)}
                                    </div>
                                </div>

                                <div className="app-info-stats-card">
                                    <h4 className="app-info-stats-title">Configuration Summary</h4>
                                    <div className="app-info-stats-grid">
                                        <div className="app-info-stat">
                                            <span className="app-info-stat-label">Total Settings</span>
                                            <span className="app-info-stat-value">
                                                {Object.keys(getDataInfo).length}
                                            </span>
                                        </div>
                                        <div className="app-info-stat">
                                            <span className="app-info-stat-label">Configured</span>
                                            <span className="app-info-stat-value">
                                                {Object.keys(getDataInfo).filter(k => getDataInfo[k] && getDataInfo[k] !== '' && getDataInfo[k] !== false).length}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div style={{ width: '100%' }}>
                            <div className="app-info-features-header" style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                                <div>
                                    <h3 className="app-info-features-title" style={{ fontSize: '1.125rem', fontWeight: 600, margin: 0 }}>Menu & Feature Controls</h3>
                                    <p className="app-info-features-subtitle" style={{ margin: '4px 0 0 0', fontSize: '0.75rem', color: '#64748b' }}>
                                        Enable or disable application features and menu items
                                    </p>
                                </div>
                                <div className="app-info-search">
                                    <Input
                                        placeholder="Search features..."
                                        prefix={<GlobalOutlined />}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        allowClear
                                        style={{ width: 250 }}
                                    />
                                </div>
                            </div>

                            <div className="app-info-features-content">
                                {Object.keys(filteredGroupedFeatures).length > 0 ? (
                                    Object.entries(filteredGroupedFeatures).map(([category, switches]) =>
                                        renderSwitchGroup(category, switches)
                                    )
                                ) : (
                                    <div className="app-info-no-results" style={{ textAlign: 'center', padding: '60px 20px', color: '#64748b' }}>
                                        <InfoCircleOutlined style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.5 }} />
                                        <p>No features found matching "{searchTerm}"</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="app-info-footer-note">
                    <InfoCircleOutlined />
                    <span>Changes are applied immediately after saving. Some features may require server restart.</span>
                </div>
            </div>
        </div>
    );
}

export default AppInfo;